export interface AddressComponent {
  types: string[];
  long_name: string;
}

export interface ParsedAddress {
  streetNumber: string;
  route: string;
  locality: string;
  state: string;
  postalCode: string;
  country: string;
}

export class AddressParser {
  private readonly addressComponents: AddressComponent[];

  constructor (addressComponents: AddressComponent[]) {
    this.addressComponents = addressComponents;
  }

  private getComponent(type: string): string {
    return this.addressComponents.find((c) => c.types.includes(type))?.long_name ?? '';
  }

  public parse(): ParsedAddress {
    return {
      streetNumber: this.getComponent('street_number'),
      route: this.getComponent('route'),
      locality: this.getComponent('locality'),
      state: this.getComponent('administrative_area_level_1'),
      postalCode: this.getComponent('postal_code'),
      country: this.getComponent('country'),
    };
  }
}
